import { Burger, Header, MediaQuery, Text } from "@mantine/core";
import React from "react";

import { IconStethoscope } from '@tabler/icons';

const CustomHeader = ({ opened, setOpened, theme }) => {
  return (
    <Header height={70} p="md">
      <div style={{ display: "flex", alignItems: "center", height: "100%" }}>
        <MediaQuery largerThan="sm" styles={{ display: "none" }}>
          <Burger
            opened={opened}
            onClick={() => setOpened((o) => !o)}
            size="sm"
            color={theme.colors.gray[6]}
            mr="xl"
          />
        </MediaQuery>

        <IconStethoscope style={{marginRight: theme.spacing.sm}}/>
        <Text>Doctor Booking Page</Text>
      </div>
    </Header>
  );
};

export default CustomHeader;
